import { queryOptions } from '@tanstack/react-query';
import type { PromotionTaskListQuery, PromotionTaskListResponse } from '@upme/contracts';
import { api } from '../../app/api-client';

export const promotionTasksKey = ['admin', 'promotion-tasks'] as const;

export type PromotionTaskListFilters = Partial<Omit<PromotionTaskListQuery, 'limit'>> & { limit?: number };

function buildSearchParams(filters: PromotionTaskListFilters): URLSearchParams {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v === undefined || v === null || v === '') continue;
    params.set(k, String(v));
  }
  return params;
}

export const listPromotionTasksOptions = (filters: PromotionTaskListFilters = {}) =>
  queryOptions({
    queryKey: [...promotionTasksKey, 'list', filters] as const,
    queryFn: () =>
      api
        .get('admin/promotion-tasks', { searchParams: buildSearchParams(filters) })
        .json<PromotionTaskListResponse>(),
    staleTime: 5_000,
  });
